export default {
  state: {
    message: '',
    error: '',
    isRegistrationFull: false,
  },

  getters: {
    getMessage(state) {
      return state.message;
    },
    getError(state) {
      return state.error;
    },
    hasMessage(state) {
      return state.message !== '';
    },
    hasError(state) {
      return state.error !== '';
    },
    isRegistrationFull(state) {
      return state.isRegistrationFull;
    },
  },

  mutations: {
    setMessage(state, message) {
      state.message = message;
    },
    setError(state, error) {
      state.error = error;
    },
    setRegistrationFull(state, full) {
      state.isRegistrationFull = full;
    },
  },

  actions: {
    createMessage({ commit }, message) {
      commit('setMessage', message);
    },
    createError({ commit }, error) {
      commit('setError', error);
    },
    createRegistrationFull({ commit }) {
      commit('setRegistrationFull', true);
    },
    clearMessage({ commit }) {
      commit('setMessage', '');
    },
    clearError({ commit }) {
      commit('setError', '');
    },
    clearRegistrationFull({ commit }) {
      commit('setRegistrationFull', false);
    },
  },
};
